import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
// -
import NoConfigsData from "../configs/NoConfigsData";
import TableMQTTBasics from "./TableMQTTBasics";
import LoaderSpinner from "context/LoaderSpinner";
import TopBarActions from "components/TopBarActionsFree";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import OrderingModel from "components/ordering/OrderingModel";
import ButtonsActions from "../../utils/buttonsActions";

import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import ItemsModel from "core/itemsModel";
import FilterModel from "components/FilterModel";
import {PagerModel} from "components/paginator/PaginationModel";
import {useTranslation} from "react-i18next";
import axiApi from "ApiCaller";

const TabBasic = () => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tags");
    document.title = _Tc("mqttTypes.b");
    const buttonsAct = new ButtonsActions();
    const [buttonsTB, setButtonsTB] = useState({
        ...buttonsAct,
        title: document.title,
    });
    const navigate = useNavigate();
    const AlertQuestion = new SwalAlertChoice({
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    });
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShow, setItemsShow] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const [item, setItem] = useState({});

    const headersTable = [
        {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("common.description"), attr: 1, direction: "asc", active: false},
        {name: _Tt("common.model"), attr: 2, direction: "asc", active: false},
    ];

    useEffect(() => {
        const buttons = {...buttonsAct};
        buttons.title = document.title;
        buttons.add.active = true;
        buttons.add.disabled = true;
        buttons.add.onClick = () => {
            navigate("/advanced/mqtt/basic/add/");
        };
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchPostData();
        };
        filters.current.filter = () => {
            pagerModelRef.current.paging.page = 1;
            fetchPostData();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchPostData();
        items.current.setItem = setItem;
        items.current.item = {};
        items.current.setShowPrev = setShowPrev;
        fetchGetData();
    }, []);

    const fetchGetData = async () => {
        setIsLoading(true);
        const resp = await axiApi.get("/api/devices/network/mqtts/basic/");
        if (resp.data) {
            pagerModelRef.current.active = resp.data.items.length > 0;
            items.current.showed = [...resp.data.items];
            items.current.clearChosen();
            setButtonsTB((prevButtons) => ({
                ...prevButtons,
                add: {
                    ...prevButtons.add,
                    disabled: resp.data.models.length === 0,
                },
            }));
            setItemsShow([...items.current.showed]);
            pagerModelRef.current.paging.setPager(resp.data);
        }
        setIsLoading(false);
    };

    const fetchPostData = async () => {
        setIsLoading(true);
        const resp = await axiApi.post("/api/devices/network/mqtts/basic/", filters.current.chosen, {
            params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
        });
        if (resp.data.status) {
            items.current.setShowed(resp.data.items);
            setItemsShow([...resp.data.items]);
            pagerModelRef.current.paging.setPager(resp.data);
        } else {
            console.error("Error en alertSetup.api()");
            Alert.warning("Error en el servicio", "No se han podido recuperar las alertas");
        }
        setIsLoading(false);
    };

    const onClickEdit = (e) => {
        if (!items.current.chosen.length || items.current.chosen.length > 1) {
            return false;
        }
        let chosen = items.current.chosen[0];
        navigate(`/advanced/mqtt/basic/${chosen}/`);
    };

    const onClickDelete = (e) => {
        AlertQuestion.fire("Se eliminaran", "Todos los seleccionados").then((r) => {
            if (r.isConfirmed) {
                let ids = items.current.getChosenIds();
                axiApi
                    .delete("/api/devices/network/mqtts/basic/", {
                        data: {ids: ids},
                    })
                    .then((r) => {
                        if (r.data.status) {
                            Alert.success("Confirmado", "Se han eliminado correctamente");
                            // Filtra los items eliminados
                            items.current.showed = items.current.showed.filter((item) => !ids.includes(item.id));
                            items.current.clearChosen();
                            setItemsShow([...items.current.showed]);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        if (err.response.status === 404) {
                            Alert.error("Error en el servidor", "El id enviado no esta accesible.");
                        } else {
                            Alert.error("Error en el servidor", "Consultar con el administrador.");
                        }
                    })
                    .finally(() => {
                        const buttons = {...buttonsTB};
                        buttons.delete.disabled = true;
                        buttons.edit.disabled = true;
                    });
            }
        });
    };

    return (
        <>
            <TopBarActions actions={buttonsTB} filtersRef={filters} className="pt-0" />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <LoaderSpinner isLoading={isLoading}>
                <NoConfigsData items={itemsShow}>
                    <TableMQTTBasics
                        items={items}
                        itemsShow={itemsShow}
                        buttonsTB={buttonsTB}
                        setButtonsTB={setButtonsTB}
                        checkAll={checkedAll}
                        setCheckAll={setCheckedAll}
                        orderingRef={orderingRef}
                    />
                </NoConfigsData>
            </LoaderSpinner>
        </>
    );
};
export default TabBasic;
